(function(){
  var root=document.querySelector('[data-ob-bundle]');
  if(!root||root.dataset.obInit)return; root.dataset.obInit='1';
  var MAXQ=parseInt(root.dataset.maxq||'4',10);
  var FREEQ=parseInt(root.dataset.freeq||'4',10);
  var FREE_SHIP_AT=2;
  var DEFAULT=parseInt(root.dataset.default||'1',10);
  var CID=root.dataset.currentId, CHANDLE=root.dataset.currentHandle, CTYPE=root.dataset.currentType;
  var EX_TAGS=(root.dataset.excludeTags||'').toLowerCase().split(',').map(function(s){return s.trim();}).filter(Boolean);
  var EX_HANDLES=(root.dataset.excludeHandles||'').toLowerCase().split(',').map(function(s){return s.trim();}).filter(Boolean);
  var PAGE_SIZE=24;
  // Swap-pool sources. Products are tagged with their type and de-duplicated (first source wins).
  var POOL_SOURCES=[
    {key:'tee',label:'T-shirts',handle:'t-shirts-frontprints-only'},
    {key:'backprint',label:'Backprints',handle:'printful-backprints'},
    {key:'crop',label:'Crop tops',handle:'crop-tops'},
    {key:'tank',label:'Tank tops',handle:'tank-tops'}
  ];
  var cache={}, pool=[], recProducts=[], currentProduct=null, unitPrice=0;
  var slots=[], active=DEFAULT;
  var addBtn=root.querySelector('[data-ob-add]');
  var shipEl=root.querySelector('[data-ob-ship]');
  var tierEls=Array.prototype.slice.call(root.querySelectorAll('[data-ob-tier]'));

  /* ── Free-shipping saving in the shopper's PRESENTMENT currency
     (Shopify.currency.active) so it always matches the prices on screen —
     never geolocation, which can disagree with the displayed currency.
     Rates mirror the store's delivery profile (GBP 3.99 / USD 3.99 / EUR 4.99 /
     CAD 6.99 / AUD 6.99). Unknown currency → 0, and everything ship-related
     falls back to plain "FREE shipping" with no compare price. ── */
  var SHIP_SAVE=(function(){
    var CURSHIP={GBP:3.99,USD:3.99,EUR:4.99,CAD:6.99,AUD:6.99};
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'';
    return CURSHIP[cur]||0;
  })();
  (function(){
    if(!SHIP_SAVE)return;
    var amt;
    try{amt=new Intl.NumberFormat(undefined,{style:'currency',currency:Shopify.currency.active,currencyDisplay:'narrowSymbol'}).format(SHIP_SAVE);}catch(e){return;}
    root.querySelectorAll('[data-ob-shiptag]').forEach(function(el){
      el.textContent='🚚 FREE shipping — save '+amt;
    });
  })();

  // Move the swap-picker overlay to <body> so position:fixed is relative to the viewport
  // (inside the product section a transformed ancestor traps it, hiding the top bar under the header).
  var pickerModal=root.querySelector('[data-ob-picker]');
  var pickerSlot=null, pickerFilter='all', pickerSearchVal='', pickerPage=0, pickerFiltered=[];
  if(pickerModal){
    pickerModal.style.zIndex='2147483000';
    document.body.appendChild(pickerModal);
    // Inject the type-filter chips above the grid.
    var pbar=document.createElement('div'); pbar.className='ob-picker__filters'; pbar.setAttribute('data-ob-filters','');
    [{k:'all',l:'All'}].concat(POOL_SOURCES.map(function(s){return {k:s.key,l:s.label};})).forEach(function(f){
      var b=document.createElement('button'); b.type='button'; b.textContent=f.l; b.setAttribute('data-ob-filter',f.k);
      if(f.k==='all')b.className='is-active'; pbar.appendChild(b);
    });
    var barEl=pickerModal.querySelector('.ob-picker__bar');
    if(barEl&&barEl.parentNode){ barEl.parentNode.insertBefore(pbar, barEl.nextSibling); }
    // Wire picker controls once (modal is persistent).
    var searchEl=pickerModal.querySelector('[data-ob-picker-search]');
    if(searchEl)searchEl.addEventListener('input',function(e){ pickerSearchVal=e.target.value.toLowerCase(); pickerCompute(); });
    pbar.addEventListener('click',function(e){
      var btn=e.target.closest&&e.target.closest('[data-ob-filter]'); if(!btn)return;
      pickerFilter=btn.getAttribute('data-ob-filter');
      Array.prototype.forEach.call(pbar.children,function(c){c.classList.toggle('is-active',c===btn);});
      pickerCompute();
    });
    var pPrev=pickerModal.querySelector('[data-ob-prev]'), pNext=pickerModal.querySelector('[data-ob-next]'), pClose=pickerModal.querySelector('[data-ob-picker-close]');
    if(pPrev)pPrev.addEventListener('click',function(){ pickerPage--; pickerDraw(); });
    if(pNext)pNext.addEventListener('click',function(){ pickerPage++; pickerDraw(); });
    if(pClose)pClose.addEventListener('click',function(){ pickerModal.hidden=true; });
  }

  function normTags(t){ if(!t)return []; if(typeof t==='string')t=t.split(','); return t.map(function(x){return (''+x).toLowerCase().trim();}); }
  function isExcluded(p){
    if(!p)return false;
    var h=(p.handle||'').toLowerCase();
    if(EX_HANDLES.indexOf(h)>-1) return true;
    if(!EX_TAGS.length) return false;
    var tags=normTags(p.tags);
    return EX_TAGS.some(function(t){return tags.indexOf(t)>-1;});
  }

  function money(c){ var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP'; try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur,currencyDisplay:'narrowSymbol'}).format(c/100);}catch(e){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100);}catch(e2){return '\u00A3'+(c/100).toFixed(2);}} }
  function getProduct(h){ if(cache[h])return Promise.resolve(cache[h]); return fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(p){cache[h]=p;return p;}); }
  function optionNames(p){ return (p.options||[]).map(function(o){return typeof o==='string'?o:o.name;}); }
  function firstAvail(p){ return (p.variants.filter(function(v){return v.available!==false;})[0])||p.variants[0]; }
  function imgSrc(x){ return !x?'':(typeof x==='string'?x:(x.src||'')); }

  function loadCollection(handle){
    var all=[];
    function page(p){
      return fetch('/collections/'+handle+'/products.json?limit=250&page='+p).then(function(r){return r.json();}).then(function(d){
        var prods=(d&&d.products)||[];
        all=all.concat(prods);
        if(prods.length===250 && p<10) return page(p+1);
        return all;
      }).catch(function(){return all;});
    }
    return page(1);
  }
  function loadAllPool(){
    return Promise.all(POOL_SOURCES.map(function(src){
      return loadCollection(src.handle).then(function(prods){ return prods.map(function(p){ p._ptype=src.key; return p; }); });
    })).then(function(lists){
      var merged=[], seen={};
      lists.forEach(function(list){ list.forEach(function(p){ if(seen[p.handle])return; seen[p.handle]=1; merged.push(p); }); });
      return merged;
    });
  }

  function buildPickers(slot){
    var p=slot.product, host=slot.el.querySelector('[data-ob-pickers]'); host.innerHTML='';
    var chosen=firstAvail(p); var chosenOpts=chosen?(chosen.options||[chosen.option1,chosen.option2,chosen.option3]):[];
    optionNames(p).forEach(function(name,idx){
      var vals=[]; p.variants.forEach(function(v){var val=(v.options&&v.options[idx])||v['option'+(idx+1)]; if(val!=null&&vals.indexOf(val)===-1)vals.push(val);});
      var sel=document.createElement('select'); sel.setAttribute('aria-label',name);
      vals.forEach(function(val){var o=document.createElement('option');o.value=val;o.textContent=val;sel.appendChild(o);});
      if(chosenOpts[idx]!=null) sel.value=chosenOpts[idx];
      sel.addEventListener('change',function(){syncVariant(slot);});
      host.appendChild(sel);
    });
    syncVariant(slot);
  }
  function syncVariant(slot){
    var p=slot.product;
    var chosen=Array.prototype.map.call(slot.el.querySelectorAll('[data-ob-pickers] select'),function(s){return s.value;});
    var m=p.variants.find(function(v){var vo=v.options||[v.option1,v.option2,v.option3];return chosen.every(function(c,i){return vo[i]===c;});});
    slot.variantId=m?m.id:null; slot.price=m?m.price:p.price; slot.available=m?m.available!==false:false;
    if(slot.mediaEl){
      var src=(m&&m.featured_image&&imgSrc(m.featured_image))||imgSrc(p.featured_image)||imgSrc(p.images&&p.images[0]);
      if(src){
        var imgEl=slot.mediaEl.querySelector('img');
        if(imgEl){ if(imgEl.getAttribute('src')!==src) imgEl.src=src; }
        else { slot.mediaEl.innerHTML='<img src="'+src+'" alt="" width="54" height="54" loading="lazy">'; }
      }
    }
    recalc();
  }
  var SWAP_ICON='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4 3 8l4 4"></path><path d="M3 8h14"></path><path d="m17 20 4-4-4-4"></path><path d="M21 16H7"></path></svg>';
  function makeRow(isCur){
    var row=document.createElement('div'); row.className='ob-srow'+(isCur?' is-current':'');
    row.innerHTML='<div class="ob-srow__media"><div class="ob-skel"></div></div>'+
      '<div class="ob-srow__body">'+
        '<p class="ob-srow__name ob-skel ob-skel--text"></p>'+
        '<button type="button" class="ob-srow__swap" data-ob-swap>'+SWAP_ICON+'<span>Swap design</span></button>'+
        '<div class="ob-srow__pickers" data-ob-pickers></div>'+
      '</div>';
    return row;
  }
  function fillSlot(el,product,isCurrent){
    var slot={el:el,product:product,variantId:null,price:product.price,available:true,mediaEl:el.querySelector('.ob-srow__media')};
    var name=el.querySelector('.ob-srow__name'); if(name){name.textContent=product.title;name.classList.remove('ob-skel','ob-skel--text');}
    var img=imgSrc(product.featured_image)||imgSrc(product.images&&product.images[0]);
    if(slot.mediaEl){slot.mediaEl.innerHTML=img?('<img src="'+img+'" alt="" width="54" height="54" loading="lazy">'):'';}
    var sw=el.querySelector('[data-ob-swap]'); if(sw){sw.onclick=function(e){e.preventDefault();openPicker(slot);};}
    var ix=slots.findIndex(function(s){return s.el===el;}); if(ix>-1)slots[ix]=slot; else slots.push(slot);
    buildPickers(slot);
  }
  function selectTier(n){
    active=n;
    var activeBox=null;
    tierEls.forEach(function(t){
      var tn=parseInt(t.dataset.obTier,10);
      var box=t.querySelector('[data-ob-tier-slots]');
      var radio=t.querySelector('[data-ob-tier-radio]');
      if(tn===n){ t.classList.add('is-active'); if(radio)radio.checked=true; box.hidden=false; activeBox=box; }
      else { t.classList.remove('is-active'); box.hidden=true; box.innerHTML=''; }
    });
    slots=[];
    if(!activeBox){recalc();return;}
    activeBox.innerHTML='';
    var rows=[];
    for(var i=0;i<n;i++){ var isCur=(i===0); var row=makeRow(isCur); activeBox.appendChild(row); rows.push(row); }
    if(currentProduct) fillSlot(rows[0],currentProduct,true);
    for(var j=1;j<n;j++){ if(recProducts[j-1]) fillSlot(rows[j],recProducts[j-1],false); }
    recalc();
  }
  /* Compare-at for a tier: 4th-free tiers cross out the full subtotal;
     free-shipping tiers (2–3) cross out subtotal + shipping so the saving
     reads as money next to the real price. */
  function tierCompare(n,sub){
    if(n>=FREEQ) return money(sub);
    if(n>=FREE_SHIP_AT && SHIP_SAVE) return money(sub+Math.round(SHIP_SAVE*100));
    return '';
  }
  function recalc(){
    var ready=slots.length===active && slots.every(function(s){return s.variantId&&s.available;});
    var prices=slots.map(function(s){return s.price;});
    var sub=prices.reduce(function(a,b){return a+b;},0);
    var free=(active>=FREEQ&&prices.length)?Math.min.apply(null,prices):0;
    var total=sub-free;
    var msg;
    if(active>=FREEQ) msg='\uD83C\uDF89 Cheapest shirt FREE + free shipping';
    else if(active>=FREE_SHIP_AT) msg='\u2705 Free shipping unlocked';
    else msg='\uD83D\uDE9A Add '+(FREE_SHIP_AT-active)+' more to unlock FREE shipping';
    shipEl.textContent=msg;
    var label = active>=FREEQ ? ('Add '+active+' to cart') : (active===1?'Add to cart':('Add '+active+' to cart'));
    if(ready) label += ' \u00B7 '+money(total);
    addBtn.textContent=label;
    addBtn.disabled=!ready;
    tierEls.forEach(function(t){
      var tn=parseInt(t.dataset.obTier,10);
      var tl=t.querySelector('[data-ob-tier-total]');
      var cp=t.querySelector('[data-ob-tier-compare]');
      if(tn===active && slots.length===active){
        if(tl)tl.textContent=money(total);
        if(cp)cp.textContent=tierCompare(active,sub);
      } else {
        var s2=unitPrice*tn, f2=(tn>=FREEQ)?unitPrice:0;
        if(tl)tl.textContent=money(s2-f2);
        if(cp)cp.textContent=tierCompare(tn,s2);
      }
    });
  }
  function renderTierPrices(){
    tierEls.forEach(function(t){
      var n=parseInt(t.dataset.obTier,10);
      var sub=unitPrice*n; var free=(n>=FREEQ)?unitPrice:0; var tot=sub-free;
      var tl=t.querySelector('[data-ob-tier-total]'); if(tl)tl.textContent=money(tot);
      var cp=t.querySelector('[data-ob-tier-compare]'); if(cp)cp.textContent=tierCompare(n,sub);
    });
  }
  function pickerDraw(){
    if(!pickerModal)return;
    var grid=pickerModal.querySelector('[data-ob-picker-grid]');
    var info=pickerModal.querySelector('[data-ob-pageinfo]');
    var prevBtn=pickerModal.querySelector('[data-ob-prev]'), nextBtn=pickerModal.querySelector('[data-ob-next]');
    var pages=Math.max(1,Math.ceil(pickerFiltered.length/PAGE_SIZE));
    if(pickerPage>pages-1)pickerPage=pages-1; if(pickerPage<0)pickerPage=0;
    var slice=pickerFiltered.slice(pickerPage*PAGE_SIZE,pickerPage*PAGE_SIZE+PAGE_SIZE);
    grid.innerHTML='';
    if(!slice.length){ grid.innerHTML='<p class="ob-picker__empty">No designs found</p>'; }
    slice.forEach(function(p){
      var el=document.createElement('div'); el.className='ob-picker__item';
      el.innerHTML='<img src="'+(p.image||'')+'" alt="" loading="lazy"><span>'+p.title+'</span>';
      el.onclick=function(){ getProduct(p.handle).then(function(full){ fillSlot(pickerSlot.el,full,false); pickerModal.hidden=true; }); };
      grid.appendChild(el);
    });
    info.textContent=(pickerFiltered.length?(pickerPage+1)+' / '+pages:'0 / 0')+' \u00B7 '+pickerFiltered.length+' design'+(pickerFiltered.length===1?'':'s');
    prevBtn.disabled=pickerPage<=0; nextBtn.disabled=pickerPage>=pages-1;
    grid.scrollTop=0;
  }
  function pickerCompute(){
    var inUse=slots.map(function(s){return s.product.handle;});
    pickerFiltered=pool.filter(function(p){return inUse.indexOf(p.handle)===-1;})
      .filter(function(p){return pickerFilter==='all'||p.ptype===pickerFilter;})
      .filter(function(p){return !pickerSearchVal||p.title.toLowerCase().indexOf(pickerSearchVal)>-1;});
    pickerPage=0; pickerDraw();
  }
  function openPicker(slot){
    if(!pickerModal)return;
    pickerSlot=slot; pickerFilter='all'; pickerSearchVal='';
    var searchEl=pickerModal.querySelector('[data-ob-picker-search]'); if(searchEl)searchEl.value='';
    var pbar=pickerModal.querySelector('[data-ob-filters]');
    if(pbar)Array.prototype.forEach.call(pbar.children,function(c){c.classList.toggle('is-active',c.getAttribute('data-ob-filter')==='all');});
    pickerModal.hidden=false;
    var grid=pickerModal.querySelector('[data-ob-picker-grid]');
    grid.innerHTML='<p class="ob-picker__empty">Loading designs\u2026</p>';
    poolReady.then(function(){ pickerCompute(); });
  }
  addBtn.addEventListener('click',function(){
    var btn=this; if(btn.dataset.busy||btn.disabled)return; btn.dataset.busy='1';
    var items=slots.map(function(s){return {id:s.variantId,quantity:1};});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(d){return {ok:r.ok,data:d};});})
      .then(function(res){
        if(!res.ok){ throw new Error((res.data&&(res.data.description||res.data.message))||'Add to cart failed'); }
        document.dispatchEvent(new CustomEvent('theme:update:cart',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('theme:open:cart-drawer',{bubbles:true}));
        try{ if(window.Alpine&&Alpine.store&&Alpine.store('modals')&&Alpine.store('modals').modals&&Alpine.store('modals').modals.cart){ Alpine.store('modals').open('cart'); } }catch(e){}
        btn.dataset.busy='';
      }).catch(function(err){ btn.dataset.busy=''; alert((err&&err.message)||'Could not add to cart. Please try again.'); });
  });

  tierEls.forEach(function(t){
    var radio=t.querySelector('[data-ob-tier-radio]');
    if(radio)radio.addEventListener('change',function(){selectTier(parseInt(t.dataset.obTier,10));});
  });

  var poolReady = loadAllPool().then(function(prods){
    pool=(prods||[]).map(function(p){return {handle:p.handle,title:p.title,type:p.product_type,image:imgSrc(p.images&&p.images[0]),tags:p.tags,ptype:p._ptype};})
                    .filter(function(p){return !isExcluded(p);});
  }).catch(function(){pool=[];});

  getProduct(CHANDLE).then(function(p){ currentProduct=p; var fa=firstAvail(p); unitPrice=fa?fa.price:p.price; renderTierPrices(); selectTier(DEFAULT); });

  poolReady.then(function(){
    return fetch('/recommendations/products.json?product_id='+CID+'&intent=related&limit=16').then(function(r){return r.json();}).then(function(d){return d.products||[];}).catch(function(){return [];});
  }).then(function(recs){
    recs=recs.filter(function(p){return !isExcluded(p)&&p.handle!==CHANDLE;});
    var handles=pool.map(function(p){return p.handle;});
    var picks=recs.filter(function(p){return handles.length===0||handles.indexOf(p.handle)>-1;});
    if(CTYPE){ picks.sort(function(a,b){return (b.product_type===CTYPE)-(a.product_type===CTYPE);}); }
    pool.forEach(function(p){ if(picks.length<MAXQ-1 && p.ptype==='tee' && p.handle!==CHANDLE && !picks.some(function(x){return x.handle===p.handle;})) picks.push(p); });
    picks=picks.filter(function(p){return p.handle!==CHANDLE;}).slice(0,MAXQ-1);
    return Promise.all(picks.map(function(p){return getProduct(p.handle);}));
  }).then(function(fulls){ recProducts=fulls||[]; if(active>1) selectTier(active); });
})();
